import { userSetupHeaderStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

userSetupHeaderStyles.assignShipToAddressButton = {
    variant: "secondary",
    css: css`
        display: none;
        margin-right: 10px;
        border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("primary")} !important;
        &:hover {
            background: ${getColor("common.background")};
            border: 2px solid ${getColor("text.accent")} !important;
        }

        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            &:hover {
                color: ${getColor("text.accent")};
            }
        }
    `,
};
userSetupHeaderStyles.saveButton = {
    css: css`
        border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
        span[class^="TypographyStyle"] {
            ${getColor("common.background")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:disabled {
            background-color: rgb(204, 204, 204) !important;
        }
        &:hover {
            background: ${getColor("text.accent")};
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            span[class^="TypographyStyle"] {
                color:${getColor("common.background")};
            }
        }
    `,
};
userSetupHeaderStyles.cancelButton={
    buttonType:"outline",
    sizeVariant:'medium',
    css: css`
        margin-right: 10px;
        padding: 10px 21px;
        span[class^="TypographyStyle"] {
        color:black;
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
    `,
};
userSetupHeaderStyles.actionButtonsHidden = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    button {
                        background: none !important;
                    }
                `,
                css`
                    button {
                        background: none !important;
                    }
                `,
                null,
                null,
                null,
            ])}
    `,
};
userSetupHeaderStyles.container ={
    gap: 8,
    css: css`
        padding-top: 40px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding-top: 0px;
                `,
                css`
                    padding-top: 0px;
                `,
                null,
                null,
                null,
            ])}
    `,
}

userSetupHeaderStyles.overflowMenu={
   cssOverrides:{
    wrapper:css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                ])};
        `,
    menu:css`
    li:first-child{
        display: none ;
            }
    `
   }
}